import React from 'react';

const NickelTabletLeftPanel = (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='413'
        height='328'
        fill='none'
        viewBox='0 0 413 328'
        preserveAspectRatio='xMinYMin slice'
    >
        <path
            fill='#00C853'
            d='M278.455 311.203l.097-.058 5.364-10.117a11.609 11.609 0 015.773 6.84 11.606 11.606 0 01-.817 8.913 11.585 11.585 0 01-6.919 5.677 11.597 11.597 0 01-8.901-.94l5.414-10.21-.011-.105z'
        ></path>
        <path
            fill='#7C79C5'
            d='M260.974 116.073l-.134.027-10.241 9.348a14.048 14.048 0 01-2.497-15.525 14.033 14.033 0 018.004-7.306 14.03 14.03 0 0110.822.568 14.039 14.039 0 014.411 3.331l-10.335 9.434-.03.123z'
        ></path>
        <path
            fill='#9B89FF'
            d='M36.638 85.884L31.61 89.17a14.31 14.31 0 01-23.956 15.655L0 109.826l.077.118a23.604 23.604 0 0026.863 9.596 23.61 23.61 0 0016.494-23.272c0-.04-.003-.08-.005-.123a23.504 23.504 0 00-3.83-12.026L39.52 84l-2.883 1.884z'
        ></path>
        <path
            fill='#7C79C5'
            d='M105.889 51.257l-.035-.204-13.772-15.91a21.312 21.312 0 0135.415 17.596 21.328 21.328 0 01-7.523 14.626l-13.899-16.057-.186-.051z'
        ></path>
        <path
            fill='#FFECD5'
            d='M216.589 34.501l.075-.224 18.308-15.476a24.275 24.275 0 00-26.061-7.74A24.284 24.284 0 00194.6 23.158a24.27 24.27 0 00-1.435 18.682 24.282 24.282 0 004.728 8.305l18.477-15.619.219-.025z'
        ></path>
        <path
            fill='#E87613'
            d='M339.697 49.708l5.277 4.723a16.873 16.873 0 0025.143 22.504l8.032 7.189-.111.124a27.834 27.834 0 01-45.614-6.079 27.84 27.84 0 01-2.493-17.565c.007-.047.018-.094.027-.143A27.722 27.722 0 01336.671 47l3.026 2.708z'
        ></path>
        <circle cx='121.068' cy='311.068' r='15.068' fill='#FF9A21' opacity='0.5'></circle>
        <circle cx='121.068' cy='311.068' r='9.627' fill='#FF9A21'></circle>
        <circle cx='391.394' cy='134.394' r='13.394' fill='#DB5019' opacity='0.2'></circle>
        <circle cx='391.393' cy='134.394' r='8.572' fill='#DB5019'></circle>
        <path
            fill='#6347FF'
            d='M394.535 295.927l-4.465-4.018a14.314 14.314 0 00-1.198-20.061 14.308 14.308 0 00-20.075.919L362 266.651l.095-.105a23.6 23.6 0 0113.106-7.392 23.609 23.609 0 0127.641 27.553c-.006.04-.016.08-.023.121a23.502 23.502 0 01-5.629 11.297l-.095.105-2.56-2.303z'
        ></path>
    </svg>
);

export default NickelTabletLeftPanel;
